import Vue from "vue";
import Vuex from "vuex";
import { UserState } from "./module/user-state";
import { TreeState } from "./module/tree-state";

Vue.use(Vuex);

// 状態保持コンテナ
export default new Vuex.Store({
  modules: {
    userState: UserState,
    treeState: TreeState
  },
});
